module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/why-pict-044d28ad55b418bda4c6b1d501c3f9e3.jpg";